function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.64576 2.35156L0.942758 10.0551C0.904005 10.094 0.876022 10.1431 0.862697 10.1958L0.00889325 13.6228C-0.0166465 13.726 0.0136681 13.8357 0.0889547 13.9109C0.145919 13.9679 0.223538 13.9994 0.302933 13.9994C0.327251 13.9994 0.352125 13.9965 0.376332 13.9903L3.80332 13.1364C3.85673 13.1231 3.90525 13.0952 3.94401 13.0565L11.6477 5.35348L8.64576 2.35156Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5561 1.30124L12.6986 0.443769C12.1255 -0.12932 11.1267 -0.128765 10.5543 0.443769L9.50391 1.49412L12.5057 4.49592L13.5561 3.44557C13.8423 3.15942 14 2.77854 14 2.37346C14 1.96838 13.8423 1.5875 13.5561 1.30124Z"
}));

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d0ba0bfb.svg";
export { ForwardRef as ReactComponent };